module.exports = __webpack_public_path__ + "static/video2-1524744a05b3c05072e75618034b3315.mp4";